import './Calculator.css';
import { userInputType } from './investment'
import {styled} from 'styled-components';

const Input = styled.input`
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 16px;
    margin-left: 4px;
    margin-right: 4px;
    width: 100px;
`;

type props = {
    onChange: (key: string, value: string) => void;
    userInput: userInputType;
    inputIsValid: boolean;
};

const Calculator: React.FC<props> = ({ onChange, userInput, inputIsValid }) => {
    return (
        <section id='user-input'>
        <h2>Investment Calculator</h2>
        <div className='input-group'>
            <p>
                <label>Initial Investment:</label>
                <input 
                type="number" 
                value={userInput.initialInvestment ? userInput.initialInvestment : 0}
                onChange={(event) => onChange("initialInvestment", event.target.value)} />
            </p>
            <p>
                <label>Annual Investment</label>
                <input 
                type="number" 
                value={userInput.annualInvestment ? userInput.annualInvestment : 0}
                onChange={(event) => onChange("annualInvestment", event.target.value)} />
            </p>
            </div>
            <div className='input-group'>
            <p>
                <label>Expected return</label>
                <input 
                type="number" 
                value={userInput.expectedReturn ? userInput.expectedReturn : 0}
                onChange={(event) => onChange("expectedReturn", event.target.value)} />
            </p>
            <p>
                <label>Duration</label>
                <Input 
                    type="number" 
                    value={userInput.duration ? userInput.duration : 0}
                    onChange={(event) => onChange("duration", event.target.value)} 
                />
            </p>
        </div>
        </section>
    );
};

export default Calculator;
